var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'GroupbuyingsList'
      }
    }
  }, [_vm._v("團購管理 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("門市庫存品開團")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("門市庫存品開團")])]), _vm.checkPermission([_vm.consts.STORE_GROUPBUYING_DRAFT]) && _vm.step == _vm.STEP.SCAN_BARCODE ? _c('router-link', {
    staticClass: "btn btn-outline-warning",
    attrs: {
      "to": {
        name: 'StoreGroupbuyingDraft'
      }
    }
  }, [_vm._v(" 編輯草稿 ")]) : _vm._e()], 1), _vm.step === _vm.STEP.SCAN_BARCODE ? [false ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "選擇分店",
      "label-for": "input-1"
    }
  }, [_c('div', [_vm.isFetchFirstLayerBranches ? _c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "secondary"
    }
  }) : _c('b-form-select', {
    staticClass: "form-control form-control-sm col-12 col-xl-6",
    attrs: {
      "state": _vm.v$.form.branch_id.$error ? false : null
    },
    on: {
      "change": _vm.handleFirstBranch
    },
    model: {
      value: _vm.firstBranch,
      callback: function callback($$v) {
        _vm.firstBranch = $$v;
      },
      expression: "firstBranch"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇分店 ")]), _vm._l(_vm.mapFirstLayerBranches, function (branch) {
    return _c('b-form-select-option', {
      key: branch.id,
      attrs: {
        "value": branch
      }
    }, [_vm._v(" " + _vm._s(branch.name) + " ")]);
  })], 2)], 1), _c('div', [_vm.isFetchSecondLayerBranches ? _c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "secondary"
    }
  }) : _vm._e(), _vm.mapSecondLayerBranches && _vm.mapSecondLayerBranches.length > 1 ? _c('b-form-select', {
    staticClass: "form-control form-control-sm col-12 col-xl-6 mt-2",
    attrs: {
      "state": _vm.v$.form.branch_id.$error ? false : null
    },
    on: {
      "change": _vm.handleSecondBranch
    },
    model: {
      value: _vm.secondBranch,
      callback: function callback($$v) {
        _vm.secondBranch = $$v;
      },
      expression: "secondBranch"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇分店 ")]), _vm._l(_vm.mapSecondLayerBranches, function (branch) {
    return _c('b-form-select-option', {
      key: branch.id,
      attrs: {
        "value": branch
      }
    }, [_vm._v(" " + _vm._s(branch.name) + " ")]);
  })], 2) : _vm._e()], 1), _c('div', [_vm.isFetchThirdLayerBranches ? _c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "secondary"
    }
  }) : _vm._e(), _vm.mapThirdLayerBranches && _vm.mapThirdLayerBranches.length > 1 ? _c('b-form-select', {
    staticClass: "form-control form-control-sm col-12 col-xl-6 mt-2",
    attrs: {
      "state": _vm.v$.form.branch_id.$error ? false : null
    },
    on: {
      "change": _vm.handleThirdBranch
    },
    model: {
      value: _vm.thirdBranch,
      callback: function callback($$v) {
        _vm.thirdBranch = $$v;
      },
      expression: "thirdBranch"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" 請選擇分店 ")]), _vm._l(_vm.mapThirdLayerBranches, function (branch) {
    return _c('b-form-select-option', {
      key: branch.id,
      attrs: {
        "value": branch
      }
    }, [_vm._v(" " + _vm._s(branch.name) + " ")]);
  })], 2) : _vm._e()], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.branch_id.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1) : _vm._e(), _c('div', {
    staticClass: "s-barcode-scanner-wrapper"
  }, [_c('BarcodeScanner', {
    staticClass: "mb-4",
    on: {
      "input": function input($event) {
        _vm.barcode = $event;
      }
    }
  }), !_vm.canBarcodeFindProduct && _vm.barcode ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_vm._v(" 查無商品 ")]) : _vm._e(), _c('b-form-input', {
    staticClass: "mt-4 mb-5",
    attrs: {
      "placeholder": "手動輸入"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchProductInfo.apply(null, arguments);
      }
    },
    model: {
      value: _vm.barcode,
      callback: function callback($$v) {
        _vm.barcode = $$v;
      },
      expression: "barcode"
    }
  }), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    }
  }, [_vm._v("取消")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.barcode
    },
    on: {
      "click": _vm.fetchProductInfo
    }
  }, [_vm._v("確認")])], 1)], 1)] : _vm._e(), _vm.step === _vm.STEP.SHOW_PRODUCT_INFO ? [_c('div', {
    staticClass: "mb-4 product-info"
  }, [_c('div', [_vm._v("國碼查詢結果：")]), _c('div', [_vm._v("品名: " + _vm._s(_vm.product.name))]), _c('div', [_vm._v("店內碼: " + _vm._s(_vm.product.barcode))]), _c('div', [_vm._v("國際碼: " + _vm._s(_vm.product.ian))]), _c('div', [_vm._v("原價: " + _vm._s(_vm.product.orig_price))]), _c('div', [_vm._v("售價: " + _vm._s(_vm.product.sale_price))])]), _c('div', {
    staticClass: "d-flex justify-content-center buttons__action"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.rescan
    }
  }, [_vm._v("重新掃描")]), _c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "success",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("掃描"), _c('br', {
    staticClass: "d-lg-none"
  }), _vm._v("其他商品")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.canClick
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("編輯"), _c('br', {
    staticClass: "d-lg-none"
  }), _vm._v("團購設定")])], 1)] : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }